import { Component, OnInit, TemplateRef, HostListener } from '@angular/core';
import { HttpHeaders, HttpClient, HttpEventType, HttpParams } from '@angular/common/http';
import { UploadfileService } from '../../services/uploadfile.service';
import { log, isNullOrUndefined } from 'util';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import { FormArray, NgModel, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { SWAlertService } from '../../services/swalert.service';
import { isNull } from '@angular/compiler/src/output/output_ast';
import { async } from 'rxjs/internal/scheduler/async';
import { filter } from '@amcharts/amcharts4/.internal/core/utils/Iterator';
import { number } from '@amcharts/amcharts4/core';
import {element} from 'protractor';
declare var Uploadfiles, Clearuploadfile, SetData, _Path, Extension, Accept, createlist: any
declare var ArrFile: any[];
@Component({
  selector: 'app-user-permission',
  templateUrl: './user-permission.component.html',
  styleUrls: ['./user-permission.component.css'],
})
export class UserPermissionComponent implements OnInit {
  UserpermissionFrom: FormGroup;
  sType: string = 'password';
  sType1: string = 'password';
  Ishide = false;
  Ishide1 = false;
  fileIO: File;
  modalRef: BsModalRef;
  company: any[] = [];
  company2: any[] = [];
  usergroup: any[] = [];
  menu: any[] = [];
  settings_com = {};
  settings_usergroup = {};
  arrReceiveMail: any[] = [];
  rdoStatus: number = 1;
  txtsearchGroupuser: any[] = [];
  isNew: boolean = true;
  IsCreate: boolean = false;
  IsForSSC: boolean = false;
  arrMenu: any[] = [];
  ReceiveMail: any = [];
  UserPermission: any[] = [];
  _ArrDataBindUser: any[] = [];
  txtSearch: string = null;
  UserID: string = null;
  sDefaultPassword: string = null;
  nID: number = 0;
  ResultPermission: boolean;
  settings: any = {};
  settingsComp: any = {};
  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      { sValue: 10 },
      { sValue: 20 },
      { sValue: 50 },
      { sValue: 100 }
    ]
  }
  _ArrData: any;
  IsDisable: any[] = [];
  IsEnable: any[] = [];
  IsEdit: boolean = false;
  IsDelete: boolean = false;
  arrDel: any[] = [];
  IsAll: boolean = false;
  test: any;
  div: any;
  txtfile: string[] = [];
  TAttachedFiles: any[] = [];
  sReferenceID: string = null;
  nUserID: number;
  IsAdmin: boolean = true;
  _MSG = "The password pattern wrong";
  //Set grid
  _ArrDataBind = [];
  sDetailData = "";
  IsHeaderSort = "";
  SortDirection = "";
  SortICO = "fas fa-sort";
  IcoSort = "fas fa-sort";
  IcoSortAsc = "fas fa-sort-up";
  IcoSortDesc = "fas fa-sort-down";
  //Head colums
  Columns = [
    { ColumnName: "Menu", SortField: "", Width: "40%" },
    { ColumnName: "Disable", SortField: "", Width: "20%" },
    { ColumnName: "Enable", SortField: "", Width: "20%" },
    { ColumnName: "Add/Edit/Delete", SortField: "", Width: "20%" },
  ]


  //Head colums User
  UserColumns = [
    //{ ColumnName: "", SortField: "", Width: "5%" },
    { ColumnName: "Emp. Code.", SortField: "sEmpCode", Width: "10%" },
    { ColumnName: "Name", SortField: "sName", Width: "22%" },
    { ColumnName: "Company", SortField: "COMPANY_NAME", Width: "25%" },
    { ColumnName: "Group User", SortField: "nRole", Width: "10%" },
    { ColumnName: "Email", SortField: "sEmail", Width: "20%" },
    { ColumnName: "", SortField: "", Width: "8%" },
  ]

  constructor(private http: HttpClient
    , private uploadService: UploadfileService
    , private System: TSFuntionService
    , private sanitized: DomSanitizer
    , private router: Router
    , private modalService: BsModalService
    , private SW: SWAlertService
    , private formBuilder: FormBuilder) { }

  async ngOnInit() {
    this.System.BlockUI();
    var regexp1 = "((?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,}))";//พิมพ์ใหญ่และตัวเลขและอักขระพิเศษ
    var regexp2 = "((?=.*[A-Z])(?=.*[0-9])(?=.*[a-z])(?=.{8,}))";
    var regexp3 = "((?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,}))";
    var regexp4 = "((?=.*[a-z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,}))";
    var regexp5 = "((?=.*[a-z])(?=.*[A-Z])(?=.*[!@#\$%\^&\*])(?=.{8,}))";
    var regexp6 = "((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,}))";//พิมพ์เล็กและพิมพ์ใหญ่และตัวเลขและอักขระพิเศษ
    let regexp = new RegExp("^(" + regexp1 + "|" + regexp2 + "|" + regexp3 + "|" + regexp4 + "|" + regexp5 + "|" + regexp6 + ")");
    var us = this.System.GetUserStorage();
    this.UserID = us.nUserID + "";
    this.sDefaultPassword = us.sDefaultPassword + "";
    this.UserpermissionFrom = this.formBuilder.group({
      nID: [null],
      txtGroupuser: ["0", Validators.required],
      txtcompany: ["", Validators.required],
      txtEmplyeeCode: [null, Validators.required],
      txtName: [null, Validators.required],
      txtSAPUser: [null],
      txtTel: [null, Validators.required],
      txtEmail: [null, [Validators.pattern("^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$"), Validators.required]],
      txtUsername: [null, Validators.required],
      txtPwd: [null,
        [Validators.required,
        Validators.pattern(regexp)]
      ],
      txtConfirmPassword: [null, Validators.required],
      rdoStatus: [1],
      txtSurname: [null, Validators.required],
      txtUnit: [null, Validators.required],
      IsROService:[false],
      file: [this.TAttachedFiles],
      txtComps: [[], Validators.required],
    })
    this.getCompany();
    this.getCompany2();
    this.getusergroup();
    this.getmenu();
    this.getreceivemail();
    this.getuserpermission();
    this.settings = {
      singleSelection: false,
      idField: 'nRole',
      textField: 'sRole',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.settingsComp = {
      singleSelection: false,
      idField: 'COMPANY_CODE',
      textField: 'COMPANY_NAME',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 10,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    //Check Permission
    let ObjData = {
      sRequestID: "",
      nMenuID: 14
    }
    var IsPermission = await this.System.CheckPermission(ObjData);
    this.ResultPermission = await this.System.CheckPermissionMeun(14);
    if (IsPermission) {
      if (!this.ResultPermission) {
        this.UserpermissionFrom.disable();
      } else {
        var setUp = {
          sID: "dvFile",
          nFileSize: 5,
          Extensions: Extension.Image,
          ModeMulti: false,
          ArrFile: ArrFile,
          View: false,
          HasURL: true,
          UrlUpload: this.System.SiteName + _Path.PathUpload,
        };
        Uploadfiles(setUp);
        Clearuploadfile();
      }
    }
    this.System.UnBlockUI();
  }

  getCompany() {
    this.http.get<any>(this.System.SiteName + "api/AdminUserpermission/GETCOMPANY").toPromise().then(res => {
      this.company = res;
    });
  }

  getCompany2() {
    this.http.get<any>(this.System.SiteName + "api/AdminUserpermission/GETCOMPANY2").toPromise().then(res => {
      this.company2 = res;
    });
  }

  getusergroup() {
    this.http.get<any>(this.System.SiteName + "api/AdminUserpermission/GETROLE").toPromise().then(res => {
      this.usergroup = res;
    });
  }

  getmenu() {
    this.http.get<any>(this.System.SiteName + "api/AdminUserpermission/GETMENU").toPromise().then(res => {
      this.menu = res;
      //This update if have menu payment report list will update isStatus to enable
      this._ArrDataBind = this.menu.map(f => ({ nMenuID: f.nMenuID, sMenuName: f.sMenuName, IsStatus: (f.nMenuID === 44 || f.sMenuName === 'Payment List Report') ? 1 : 0, sType: f.sType }));
    });
  }

  getreceivemail() {
    this.http.get<any>(this.System.SiteName + "api/AdminUserpermission/GETRECEIVEVEMAIL").toPromise().then(res => {
      this.ReceiveMail = res;
      this.arrReceiveMail = this.ReceiveMail.map(f => ({ sTitle: f.sTitle, nDataID: f.nDataID, IsStatus: false }))
    });
  }

  getuserpermission() {
    this.http.get<any>(this.System.SiteName + "api/AdminUserpermission/GETUSERPERMISSION").toPromise().then(res => {
      this.UserPermission = res.filter(f => f.IsDelete != true);
      this.BindDataUserTable();
    });
  }

  Create() {
    //call js myfunction;
    this.IsCreate = true;
    this.nID = 0;
    this.isNew = true;
    let field = ['txtcompany', 'txtEmplyeeCode', 'txtUsername']
    field.forEach(f => {
      this.UserpermissionFrom.get(f).enable();
      this.UserpermissionFrom.get(f).setValidators(Validators.required);
    });
  }

  BindDataUserTable() {
    let Arr = this.UserPermission
    if (this.txtSearch) {
      Arr = Arr.filter((item) => {
        return (item.Search).search(this.txtSearch.toUpperCase()) != -1
      });
    }

    if (this.txtsearchGroupuser.length != 0) {
      let nRole = this.txtsearchGroupuser.map(f => f.nRole)
      Arr = Arr.filter((item) => {
        return nRole.includes(item.nRole) == true
      });
    }

    this.OptionGrid.nTotalItem = Arr.length;
    let nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * this.OptionGrid.nPageSize;
    let nEndIndex_Take = this.OptionGrid.nPageSize;
    this._ArrDataBindUser = [];
    Arr.forEach(val => this._ArrDataBindUser.push(Object.assign({}, val)));
    this._ArrDataBindUser = this._ArrDataBindUser.splice(nStartIndex_Take, nEndIndex_Take);
    let nStartItemPage = nStartIndex_Take + 1;
    let nLastItemPage = nStartIndex_Take + this._ArrDataBindUser.length;
    this.sDetailData = "Showing " + nStartItemPage + " to " + nLastItemPage + " of " + Arr.length + " Rows";
  }

  Getstatus(nRole: number) {
    let status = [];
    switch (nRole) {
      case 1:
        status.push(1, 2, 3)
        break
      case 2:
        status.push(2)
        break
    }
    return status;
  }

  //#region Event
  //Event ตอนกด Click Header
  SortHeaderClick(ColumnName: string, SortField: string) {
    if (ColumnName) {
      if (ColumnName === this.IsHeaderSort) {
        this.SortDirection = this.SortDirection === 'asc' ? 'desc' : 'asc';
        this.SortICO = (this.SortDirection === 'asc') ? this.IcoSortAsc : this.IcoSortDesc;
      }
      else {
        this.SortICO = this.IcoSortAsc;
        this.SortDirection = 'asc';
      }
      this.IsHeaderSort = ColumnName;
      this.UserPermission = _.orderBy(this.UserPermission, [SortField], [this.SortDirection]);
      this.BindDataUserTable();
    }
  }

  PageSizeChange() {
    setTimeout(() => {
      this.OptionGrid.nCurrentPage = 1;
      this.BindDataUserTable();
    });

  }

  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.BindDataUserTable();
  }
  //#endregion Event

  Add() {
    // this.IsCreate = false;
    var FieldValid: string[] = [];
    if (this.IsEdit == true) {
      FieldValid = ['txtConfirmPassword', 'txtPwd', 'txtTel', 'txtEmail', 'txtUnit', 'txtSurname', 'txtName', 'txtGroupuser']
    } else {
      FieldValid = ['txtConfirmPassword', 'txtPwd', 'txtUsername', 'txtTel', 'txtEmail', 'txtUnit', 'txtSurname', 'txtName', 'txtEmplyeeCode', 'txtGroupuser']
        if (this.IsForSSC){
          FieldValid.push('txtComps')
        }
        else{
          FieldValid.push('txtcompany')
        }
    }

    let role = this.UserpermissionFrom.get('txtGroupuser').value
    if (role === "2") FieldValid.push('txtSAPUser')

    let _FormGroup = this.UserpermissionFrom;
    let IsValid: boolean = true;
    FieldValid.forEach(function (Field) {
      if (!_FormGroup.get(Field).valid) {
        IsValid = false;
        return false;
      }
    });
    let IsSignature = false;
    if (role == "3" || role == "4") {
      IsSignature = ArrFile.length != 0 ? true : false;
    } else {
      IsSignature = true;
    }
    if (IsValid && this.IsCorrect) {
      if (IsSignature) {
        let arrDave = {
          nID: this.nID,
          nRole: this.UserpermissionFrom.get('txtGroupuser').value,
          sCompCode: this.UserpermissionFrom.get('txtcompany').value,
          sEmpCode: this.UserpermissionFrom.get('txtEmplyeeCode').value,
          sName: this.UserpermissionFrom.get('txtName').value,
          sSAPUser: this.UserpermissionFrom.get('txtSAPUser').value,
          sSurName: this.UserpermissionFrom.get('txtSurname').value,
          sTel: this.UserpermissionFrom.get('txtTel').value,
          sEmail: this.UserpermissionFrom.get('txtEmail').value,
          sUserName: this.UserpermissionFrom.get('txtUsername').value,
          sPassword: this.UserpermissionFrom.get('txtConfirmPassword').value,
          cActive: this.UserpermissionFrom.get('rdoStatus').value,
          arrReceiveMail: this.arrReceiveMail,
          file: ArrFile,
          arrmenu: this._ArrDataBind,
          sUnit: this.UserpermissionFrom.get('txtUnit').value,
          UserID: this.UserID,
          sReferenceID: this.sReferenceID,
          IsROService: this.UserpermissionFrom.get('IsROService').value,
          sCompCodes: this.UserpermissionFrom.get('txtComps').value
        };
        let _this = this;
        this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Save, function () {
          _this.sendtosave(arrDave)
          _this.System.BlockUI();
        }, function () { })
      } else {
        this.System.UnBlockUI();
        this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, "Please, Add File Signature", undefined);
      }
    }
    else {
      this.System.UnBlockUI();
      let _This = this;
      FieldValid.forEach(function (Field) {
        const control = _FormGroup.get(Field);             //{3}
        if (control instanceof FormControl) {             //{4}
          control.markAsTouched({ onlySelf: true });
        }
      });
      this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Error_Information, function () { _This.System.UnBlockUI(); });
    }
  }

  sendtosave(arrDave: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    let ITEM = JSON.stringify(arrDave);
    let _this = this;
    this.http.post<any>(this.System.SiteName + 'api/AdminUserpermission/SaveDB', ITEM, { headers })
      .subscribe(res => {
        _this.System.UnBlockUI();
        if (res.Status == _this.System.SysProcess.SessionExpired) {
          _this.System.SessionExpire();
        }
        else if (res.Status == _this.System.SysProcess.Success) {
          _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, _this.SW.BoxMsg.Desc_Success_Save, function () {
            _this.Clear();
            _this.getuserpermission();
            //Swal.close();
          });
        }
        else if (res.Status == _this.System.SysProcess.Duplicate) {
          _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Warning_Duplicate, function () { });
        }
        else {
          _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, res.Msg, undefined);
        }
      });
  }

  Clear() {
    ArrFile = [];
    this.nID = 0;
    this.IsEdit = false;
    if (this.ResultPermission) {
      Clearuploadfile();
    }

    this.IsCreate = false;
    this.UserpermissionFrom = this.formBuilder.group({
      txtGroupuser: "0",
      txtcompany: "",
      txtEmplyeeCode: null,
      txtName: null,
      txtSAPUser: null,
      txtTel: null,
      txtEmail: null,
      txtUsername: null,
      txtPwd: null,
      txtConfirmPassword: null,
      rdoStatus: 1,
      txtContactName: null,
      txtSurname: null,
      txtUnit: null,
      IsROService: false,
      file: [],
      txtComps: []
    })
    this.TAttachedFiles = [];
    this._ArrDataBind.forEach(f => f.IsStatus = 0);
    this.arrReceiveMail.forEach(f => f.IsStatus = false);
    this.getmenu();
    let field = ['txtcompany', 'txtEmplyeeCode', 'txtUsername']
    field.forEach(f => { this.UserpermissionFrom.get(f).enable() });
  }

  ChangeEye(nID: any) {
    if (nID == 1) {
      this.Ishide = !this.Ishide;
      if (this.sType == 'text') {
        this.sType = 'password'
      } else {
        this.sType = 'text'
      }
    } else {
      this.Ishide1 = !this.Ishide1;
      if (this.sType1 == 'text') {
        this.sType1 = 'password'
      } else {
        this.sType1 = 'text'
      }
    }
  }
  IsPass: boolean = false;
  IsCon: boolean = false;
  IsCorrect: boolean = false;
  CheckPassword() {
    let Ps = this.UserpermissionFrom.get('txtPwd').value;
    let CPs = this.UserpermissionFrom.get('txtConfirmPassword').value;
    this.IsPass = Ps == null ? false : Ps == "" ? false : true;
    this.IsCon = CPs == null ? false : CPs == "" ? false : true;
    this.IsCorrect = Ps == CPs ? (this.IsCon == true ? true : false) : false


  }

  CheckAll() {
    if (this.IsAll) {
      this.IsDelete = true;
    } else {
      this.IsDelete = false;
    }
    this._ArrDataBindUser.forEach(f => f.IsDelete = this.IsAll);
  }

  checkDel() {
    this.IsDelete = this._ArrDataBindUser.filter(f => f.IsDelete == true).length > 0 ? true : false;
  }

  clearPass() {
    let _this = this;
    this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_reset, function () {
      _this.resetPass();
    }, undefined)
  }

  IsApprove: boolean = false
  SelectGroupuser(item) {
    if (item == "3" || item == "4" ||item == "5" || item == "7" || item == "") {
      this.IsApprove = false;
    } else {
      this.IsApprove = true;
      Clearuploadfile();
    }
    if (item == "2" || item == "6" ) {
      this.IsForSSC = true;
    } 
    
    let Mail: any[] = this.ReceiveMail.map(f => ({ sTitle: f.sTitle, nDataID: f.nDataID, IsStatus: false }))
    var us = this.System.GetUserStorage();
    var numbers: any[] = [];
    var role = item == '' ? 0 : parseInt(item, 10)
    switch (role) {
      case 0:
        numbers = [1, 2, 3, 4];
        break;
      case 2:
        numbers = [3];
        break;
      case 3:
      case 4:
        numbers = [1, 2, 3];
        break;
      case 5:
        numbers = [2, 3, 4];
        break;
    }
    //item.nDataID
    let _this = this
    this.arrReceiveMail = []
    numbers.forEach(n => {
      Mail.forEach(function (f) {
        if (n == f.nDataID) {
          _this.arrReceiveMail.push(f)
        }
      })
    })
    let data = this.menu.map(f => ({ nMenuID: f.nMenuID, sMenuName: f.sMenuName, IsStatus: 0, sType: f.sType }));
    this.UserpermissionFrom.get("txtSAPUser").clearValidators();
    this.UserpermissionFrom.get("txtSAPUser").updateValueAndValidity();
    this.UserpermissionFrom.get("txtSAPUser").markAsTouched();
    switch (role) {
      case 0:
        this._ArrDataBind = data;
        break;
      case 1:
        let menuID_A = [17, 11, 29, 30, 31, 35, 36, 43];
        this._ArrDataBind = data.filter(function (item) {
          return !menuID_A.includes(item.nMenuID);
        })
        this._ArrDataBind.forEach(f => f.IsStatus = 0);
        break;
      case 2:
        //let menuID = [12, 13, 14, 15, 16];
        //this._ArrDataBind = data.filter(function (item) {
        //  return !menuID.includes(item.nMenuID);
        //})
        this._ArrDataBind = data;
        this._ArrDataBind.forEach(f => f.IsStatus = 2);
        let letreport = this._ArrDataBind.filter(f => f.sType == "S");
        letreport.forEach(f => f.IsStatus = 1)
        //this.company.push({ COMPANY_CODE: "", COMPANY_NAME: "ทุกบริษัท", COMPANY: "", cActive: "Y" });

        this.UserpermissionFrom.get("txtSAPUser").setValidators(Validators.required);
        break;
      case 3:
      case 4:
      case 5:
      case 6:
        this._ArrDataBind = data.filter(f => f.sType == 'S');
        this._ArrDataBind.forEach(f => f.IsStatus = 0);
        break;
    }
    //}

  }

  resetPass() {
    this.System.BlockUI();
    let _this = this;
    let ua = this.System.GetUserStorage();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    let ITEM = JSON.stringify({ nID: this.nUserID })
    this.http.post<any>(this.System.SiteName + 'api/AdminUserpermission/ResetPassword', ITEM, { headers, responseType: 'json' })
      .toPromise().then(res => {
        if (res.Status == _this.System.SysProcess.SessionExpired) {
          _this.System.SessionExpire();
        }
        else if (res.Status == _this.System.SysProcess.Success) {
          _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, _this.SW.BoxMsg.Desc_Success_reset, function () {
            _this.UserpermissionFrom.patchValue({ txtPwd: _this.sDefaultPassword, txtConfirmPassword: _this.sDefaultPassword });
            _this.CheckPassword();
          });
        }
        else if (res.Status == _this.System.SysProcess.Failed) {
          _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, "", function () { });
        }
        else {
          _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, res.Msg, undefined);
        }
      });
    _this.System.UnBlockUI();
  }

  async Edit(nUserID: any) {
    this.System.BlockUI();
    this.nUserID = nUserID;
    this.System.BlockUI();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    let ITEM = JSON.stringify({ nID: nUserID })
    this.http.post(this.System.SiteName + 'api/AdminUserpermission/GETDATAbynUSERID', ITEM, { headers, responseType: 'json' })
      .toPromise().then(res => {
        let Data = res;
        if (res != null) {
          this.nID = Data[0].nID;
          var comps = [];
          Data[0].sCompCodes.forEach(f =>
            comps.push({COMPANY_CODE: f.COMPANY_CODE, COMPANY_NAME: f.COMPANY_NAME})
          );
          this.UserpermissionFrom.patchValue({
            nID: Data[0].nID,
            txtGroupuser: Data[0].nRole,
            txtcompany: Data[0].sCompCode,
            txtEmplyeeCode: Data[0].sEmpCode,
            txtName: Data[0].sName,
            txtSAPUser: Data[0].sSAPUser,
            txtSurname: Data[0].sSurName,
            txtTel: Data[0].sTel,
            txtEmail: Data[0].sEmail,
            txtUsername: Data[0].sUserName,
            txtPwd: Data[0].sPassword,
            txtConfirmPassword: Data[0].sPassword,
            rdoStatus: Data[0].cActive,
            txtUnit: Data[0].sUnit,
            IsROService: Data[0].IsROService,
            txtComps: comps
          })
          if (Data[0].nRole == "3" || Data[0].nRole == "4" || Data[0].nRole == "5" || Data[0].nRole == "7" || Data[0].nRole == "") {
            this.IsApprove = false;
          } else {
            this.IsApprove = true;
          }
          if (Data[0].nRole == "2" || Data[0].nRole == "6" ) {
            this.IsForSSC = true;
          } 
        
          let field = ['txtcompany', 'txtEmplyeeCode', 'txtUsername']
          field.forEach(f => {
            this.UserpermissionFrom.get(f).disable();
            this.UserpermissionFrom.get(f).markAsUntouched();
          });

          if (Data[0].nRole == "2") {
            this.UserpermissionFrom.get("txtcompany").enable();
            this.UserpermissionFrom.get("txtcompany").markAsTouched();
            this.UserpermissionFrom.get("txtSAPUser").setValidators(Validators.required);
          }

          this.sReferenceID = Data[0].sReferenceID;
          //_Menu.forEach(f => this.TAttachedFiles.push(f))
          let menu: any[] = Data[0].arrmenu;
          let mail: any[] = Data[0].arrReceiveMail;
          let file: any[] = Data[0].file;
          if (menu.length != 0) {
            //this._ArrDataBind = menu.map(f => ({ nMenuID: f.nMenuID, sMenuName: f.sMenuName, IsStatus: f.isStatus, sType: f.sType }))
            this._ArrDataBind = this.menu;
            this._ArrDataBind.forEach(item => {
              let lstedit = menu.filter(f => f.nMenuID == item.nMenuID)
              if (lstedit.length > 0) {
                item.IsStatus = lstedit[0].IsStatus
              }
            })
          } else {
            this._ArrDataBind.forEach(f => f.IsStatus = 0);
          }
          //Here is check permisstion for login user to have edit permission
          switch (Data[0].nRole) {
            case "1":
              let menuID_A = [17, 11, 29, 30, 31, 35, 36, 43];
              this._ArrDataBind = this._ArrDataBind.filter(function (item) {
                return !menuID_A.includes(item.nMenuID);
              })
              break;
            case "3":
            case "4":
            case "5":
            case "6":
              this._ArrDataBind = this._ArrDataBind.filter(f => f.sType == 'S');
              break;
          }
          this.arrReceiveMail = []
          if (mail.length != 0) {
            this.arrReceiveMail = mail.map(f => ({ sTitle: f.sTitle, nDataID: f.nDataID, IsStatus: f.IsStatus }))

          } else {
            this.arrReceiveMail.forEach(f => f.IsStatus = false);
          }

          let arrdata = [];
          if (file.length != 0) {
            file.forEach(f => arrdata.push({
              nID: f.nID,
              sPath: f.sPath,
              sSystemFileName: f.sSystemFileName,
              sFileName: f.sFileName,
              sSize: f.sSize
            }))
            if (!this.IsApprove) {
              if (arrdata[0].sFileName) {
                if (!this.ResultPermission) {
                  createlist('dvFile', arrdata);
                } else {
                  SetData('dvFile', arrdata)
                }
              }
            }

          }


          this.CheckPassword();
          this.IsEdit = true;
          this.isNew = false;
          this.IsCreate = true;
        }
        //this.GetMenu(Data[0].nRole);
        this.System.UnBlockUI();
      }
      );
  }

  GetMenu(item) {
    if (item == 3 || item == 4 || item == 5) {
      this.IsAdmin = false;
    } else {
      this.IsAdmin = true;
      switch (item) {
        //case '1':
        //  this._ArrDataBind = this._ArrDataBind;
        //  break;
        //case '2':
        //  let menuID = [12, 13, 14, 15, 16];
        //  this._ArrDataBind = this._ArrDataBind.filter(function (item) {
        //    return !menuID.includes(item.nMenuID);
        //  })
        //  break;
        case '3':
        case '4':
        case '5':
        case '6':
          this._ArrDataBind = this._ArrDataBind.filter(f => f.sType == 'S');
          break;
      }
    }
  }

  GetFile(event) {
    this.TAttachedFiles = event;
  }

  Delete() {
    let _This = this
    if (this.IsDelete) {
      this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Delete, function () { _This.DeleteDB() }, undefined)
    }

  }

  DeleteDB() {
    let _This = this
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    this.arrDel = this._ArrDataBindUser.filter(f => f.IsDelete == true);
    //this._ArrDataBindUser.forEach(f => this.arrDel.push({ nUserID: f.nUserID, sEmpCode: f.sEmpCode, IsDelete: f.IsDelete }))
    let ITEM = JSON.stringify(this.arrDel);
    let _this = this;
    this.System.BlockUI();
    this.http.post<any>(this.System.SiteName + 'api/AdminUserpermission/DeleteDB', ITEM, { headers })
      .subscribe(res => {
        _this.System.UnBlockUI();
        if (res.Status == _this.System.SysProcess.SessionExpired) {
          _this.System.SessionExpire();
        }
        else if (res.Status == _this.System.SysProcess.Success) {
          _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, _this.SW.BoxMsg.Desc_Success_Delete, function () {
            _this.Clear();
            _this.getuserpermission();
          });
        }
        else if (res.Status == _this.System.SysProcess.Duplicate) {
          _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Warning_Duplicate, function () { });
        }
        else {
          _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, res.Msg, undefined);
        }
      }
      );
  }
 
  //#region Validate
  isFieldValid(field: string) {
    return !this.UserpermissionFrom.get(field).valid && this.UserpermissionFrom.get(field).touched;
  }

  isEmailValid(field: string) {
    let input = this.UserpermissionFrom.get('txtEmail').value;
    let checkEmail: boolean = false
    let Regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (Regex.test(input)) {
      checkEmail = true
    }
    return !this.UserpermissionFrom.get(field).valid && this.UserpermissionFrom.get(field).touched && checkEmail;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }
  //#endregion
}


